/**
 * Created by Administrator on 2017/7/2.
 */
import { SHOWCAROUSEL, LOADCAROUSEL } from './actionTypes.js';

export const LoadCarousel = () => dispatch => {
  // axios({
  //     method: "GET",
  //     url: '/carousel',
  //     headers: {'Access-Control-Allow-Origin': '*'}
  // }).then(function (res) {
  // }).catch(function (err) {
  //   console.log(err);
  // });
  dispatch(
    ShowCarousel([
      { blogId: 1, title: 'first blog', titleImgUrl: './images/1.PNG' },
      { blogId: 2, title: 'second blog', titleImgUrl: './images/2.PNG' },
      { blogId: 3, title: 'third blog', titleImgUrl: './images/3.PNG' },
    ])
  );
};

export const ShowCarousel = carouselBlogList => ({
  type: SHOWCAROUSEL,
  carouselBlogList,
});



// WEBPACK FOOTER //
// ./src/Component/MyCarousel/actions.js